import {
  CORE,
  initialValues,
  allInitialValues,
  fromSearchParams,
} from "../filterConfig"

export const TOGGLE_COLLAPSE = "TOGGLE_COLLAPSE"
export const SET_WHOLE_STATE = "SET_WHOLE_STATE"
export const SET_MODE = "SET_MODE"
export const SET_VALUE = "SET_VALUE"
export const SET_FROM_DATE = "SET_FROM_DATE"
export const SET_TO_DATE = "SET_TO_DATE"
export const SET_COMPANY = "SET_COMPANY"
export const SET_COMPANY_INPUT = "SET_COMPANY_INPUT"
export const RESET_FORM = "RESET_FORM"

export const initState = {
  isCollapse: false,
  mode: CORE,
  values: allInitialValues,
}

const setValues = (state, changes) => ({
  ...state,
  values: { ...state.values, ...changes },
})

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case TOGGLE_COLLAPSE:
      return { ...state, isCollapse: !state.isCollapse }
    case SET_WHOLE_STATE: {
      // Keep the selected tab when nothing is applied yet.
      const { mode, values } = fromSearchParams(payload.searchParamGroup)
      return { ...state, mode: mode || state.mode, values }
    }
    case SET_MODE: {
      const { mode } = payload
      if (mode === state.mode) return state
      // Core and Advanced are exclusive: leaving a tab resets its values.
      return { ...setValues(state, initialValues[state.mode]), mode }
    }
    case SET_VALUE:
      return setValues(state, { [payload.name]: payload.value })
    case SET_FROM_DATE:
      return setValues(state, { fromDate: payload.fromDate })
    case SET_TO_DATE:
      return setValues(state, { toDate: payload.toDate })
    case SET_COMPANY:
      return setValues(state, {
        company: payload.company,
        companyInput: payload.company.name,
      })
    case SET_COMPANY_INPUT:
      return setValues(state, {
        company: null,
        companyInput: payload.companyInput,
      })
    case RESET_FORM:
      return { ...state, values: allInitialValues }
    default:
      throw new Error("Unknown action")
  }
}
